import { api } from '@api/api2';

const changeAdditionalFieldsTicket = (payload: Record<string, unknown>) =>
  api.v1('post', 'tck/bms/tickets/item/set-fields', payload, {
    headers: { 'Content-Type': 'application/json' },
  });

export const ticketAdditionalFieldsApi = {
  changeAdditionalFieldsTicket,
};
